export enum Authority {
  ProjectOwner = 'PROJECT_OWNER',
  ProjectManager = 'PROJECT_MANAGER',
  ProjectMember = 'PROJECT_MEMBER'
}
